"use strict";
/* eslint no-param-reassign: ["error", { "props": false }] */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("../shared/constants");
function getCondition(props) {
    return props.condition || constants_1.default.DEFAULT_CONDITION;
}
function emptyVal(val) {
    return val === null || val === undefined || val === '';
}
function removeEmptyParams(params) {
    Object.keys(params).forEach(function (prop) {
        if (Array.isArray(params[prop])) {
            params[prop] = params[prop].filter(function (val) { return !emptyVal(val); });
            if (params[prop].length === 0) {
                delete params[prop];
            }
        }
        else if (params[prop] && typeof params[prop] === 'object') {
            removeEmptyParams(params[prop]);
        }
        else if (emptyVal(params[prop])) {
            delete params[prop];
        }
    });
}
function handleItemRegion(params) {
    if (Array.isArray(params.item_region)) {
        var nonNullRegions = params.item_region.filter(function (val) { return !emptyVal(val); });
        params.item_region = nonNullRegions.pop();
    }
}
function handleShipsTo(params) {
    var code = params.ships_to || params.region;
    params.ships_to = code;
    delete params.region;
}
function removeDefaultPage(params) {
    if (params.page === constants_1.default.DEFAULT_PAGE) {
        delete params.page;
    }
}
function buildSearchParams(props) {
    var params = tslib_1.__assign(tslib_1.__assign({}, props), { condition: getCondition(props) });
    if (params.featured_id)
        delete params.bumped;
    if (params.requestFacets) {
        params.facets = true;
    }
    delete params.requestFacets;
    if (params.shopSlug) {
        params.shop = params.shopSlug;
        delete params.shopSlug;
    }
    if (params.perPage) {
        params.per_page = params.perPage;
        delete params.perPage;
    }
    handleShipsTo(params);
    removeEmptyParams(params);
    removeDefaultPage(params);
    handleItemRegion(params);
    return params;
}
exports.default = buildSearchParams;
//# sourceMappingURL=build_search_params.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/build_search_params.js
// module id = eq+H
// module chunks = 20 21